import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LiveClassCountdownTimerService } from '../../live-class-section/services/live-class-countdown-timer.service';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassWithCountdownTimerComponent {
  @Input() liveClass: LiveClassDto;
  constructor(private liveClassCountdownTimerService: LiveClassCountdownTimerService) {}

  public get minutes(): string {
    return this.liveClassCountdownTimerService.minutes(this.liveClass.signupEnabled, this.liveClass.classBegin);
  }

  public get seconds(): string {
    return this.liveClassCountdownTimerService.seconds();
  }

  public get labelKey(): string {
    if (this.liveClass.signupEnabled) {
      return this.liveClassCountdownTimerService.labelKey;
    } else {
      return 'studybundle.liveClasses.nextLiveClassMessage';
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/live-class-with-countdown-timer/live-class-with-countdown-timer.component.ts